import "./App.css";
import { Nav, Bio, Gallery } from "./components";

function App() {
	return (
		<div className="container">
			<Nav />
			<Bio />
			<Gallery />
		</div>
	);
}

export default App;
